
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
    const slides = Array.from(rotator.querySelectorAll('[data-announcement-slide]'));
    const prev = rotator.querySelector('[data-announcement-prev]');
    const next = rotator.querySelector('[data-announcement-next]');
    if (slides.length < 2) return;
    let index = slides.findIndex(s => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }
    if (prev) prev.addEventListener('click', () => show(index - 1));
    if (next) next.addEventListener('click', () => show(index + 1));
    let timer = window.setInterval(() => show(index + 1), 4200);
    rotator.addEventListener('mouseenter', () => window.clearInterval(timer));
    rotator.addEventListener('mouseleave', () => { window.clearInterval(timer); timer = window.setInterval(() => show(index + 1), 4200); });
    rotator.addEventListener('focusin', () => window.clearInterval(timer));
    rotator.addEventListener('focusout', () => { window.clearInterval(timer); timer = window.setInterval(() => show(index + 1), 4200); });
  });

  document.querySelectorAll('[data-style-selector]').forEach(function (selector) {
    const options = Array.from(selector.querySelectorAll('[data-style-option]'));
    const output = selector.querySelector('[data-style-output]');
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(o => {
          o.classList.remove('is-selected');
          o.setAttribute('aria-pressed', 'false');
        });
        option.classList.add('is-selected');
        option.setAttribute('aria-pressed', 'true');
        if (output) output.textContent = option.getAttribute('data-detail') || '';
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    function updatePrice() {
      const selected = select.options[select.selectedIndex];
      const price = selected && selected.getAttribute('data-price');
      const target = document.querySelector(select.getAttribute('data-price-target'));
      if (target && price) target.textContent = price;
    }
    select.addEventListener('change', updatePrice);
    updatePrice();
  });
});
